import { createContext } from 'react';
import { ApolloError } from 'apollo-client';
import { IGetUserIdentityQuery } from 'src/graphql/queries/getUserIdentity/queries.types';

export type TCurrentAdmin = IGetUserIdentityQuery['identity']['currentAdmin'];
export type TCurrentConcierge = IGetUserIdentityQuery['identity']['currentConcierge'];

interface IUserContext {
  loading: boolean;
  error?: ApolloError;
  currentAdmin?: TCurrentAdmin;
  currentConcierge?: TCurrentConcierge;
  isLoggedIn: boolean;
  refetchIdentity?: () => void;
}

export const UserContext = createContext<IUserContext>({
  loading: false,
  error: undefined,
  currentAdmin: null,
  currentConcierge: null,
  isLoggedIn: false,
  refetchIdentity: () => {},
});
